import { doc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebaseConfig'

export async function rejectMissionClaim(claimId, reason = '') {
  try {
    const claimLogRef = doc(db, 'mission_claim_logs', claimId)
    
    // 1. Ambil data Log dulu untuk tahu siapa Mitra-nya
    const claimSnap = await getDoc(claimLogRef)
    
    if (!claimSnap.exists()) {
      throw new Error("Data klaim tidak ditemukan")
    }

    const data = claimSnap.data()
    
    // Pastikan data mitraRef ada (dikirim dari Flutter)
    if (!data.mitraRef || !data.missionId) {
      throw new Error("Data referensi Mitra rusak/hilang")
    }

    // ✨ PERBAIKAN: Sesuaikan dengan nama sub-koleksi misi di Flutter
    const subCollection = data.missionType === 'weekly' 
        ? 'missions_weekly' 
        : 'missions_daily'

    // 3. Update Status di Dokumen Pribadi Mitra (Supaya di HP muncul 'Ditolak')
    const mitraMissionRef = doc(db, `${data.mitraRef}/${subCollection}/${data.missionId}`)
    
    await updateDoc(mitraMissionRef, {
      claimed: false, // ✨ PERBAIKAN: Reset jadi false agar mitra bisa mencoba klaim ulang jika itu error sistem
      status: 'rejected', 
      rejectedReason: reason,
      checkedAt: serverTimestamp()
    })

    // 4. Update Status di Log Admin
    await updateDoc(claimLogRef, {
      rejected: true,
      rejectedAt: serverTimestamp(),
      rejectReason: reason,
      approved: false,
      approvedAt: null,
    })

    console.log("Klaim berhasil ditolak dan status mitra diperbarui.")

  } catch (error) {
    console.error("Gagal menolak klaim:", error)
    throw error
  }
}